<template>
  <div>
    <landlord-request-table/>
  </div>
</template>

<script>
export default {
  components: {
    "landlord-request-table": () => import("@/landlord/components/LandlordRequestDataTable.vue"),
  },
  data() {
    return {
      //
    };
  }
};
</script>
<style scoped>

</style>